import "antd/dist/antd.css";
import "./dayjs";
import ReactDOM from "react-dom/client";
import "/src/i18n";
import { Root } from "./containers/Root";
import "./index.css";
import "./styles";
import "./services/apis/urlToken";

ReactDOM.createRoot(document.getElementById("root")!).render(<Root />);
